import React from 'react';
import { SpinnerIcon, CheckCircleIcon } from '../../Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../firebase/firebaseConfig';

interface BrochureStatusFeedbackProps {
  status: 'loading' | 'success';
  emails: string[];
  processedCount?: number;
  onClose: () => void;
}

export const BrochureStatusFeedback: React.FC<BrochureStatusFeedbackProps> = ({
  status,
  emails,
  processedCount,
  onClose,
}) => {
  if (status === 'loading') {
    return (
      <div className="text-center py-8">
        <SpinnerIcon className="w-12 h-12 text-sky-600 mx-auto mb-4 animate-spin" />
        <p className="text-lg font-semibold text-gray-700">Generando Brochure...</p>
        <p className="text-sm text-gray-500 mt-2">
          Estamos procesando tu solicitud en el servidor. Recibirás un correo en breve.
        </p>
      </div>
    );
  }

  return (
    <div className="text-center py-8">
      <CheckCircleIcon className="w-16 h-16 text-green-500 mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-gray-800">¡Brochure en camino!</h3>
      <p className="text-gray-600 mt-2 break-words">
        El proceso se ha iniciado {processedCount ? `para ${processedCount} inmueble(s)` : ''}.
        Se enviará a <span className="font-medium text-sky-700">{emails.join(', ')}</span>.
      </p>
      <button
        onClick={onClose}
        className="mt-6 px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
        style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
      >
        Cerrar
      </button>
    </div>
  );
};
